module.exports = __webpack_public_path__ + "img/menu_icon03.737b71e2.png";